module.exports = __webpack_public_path__ + "img/C06TechRoyalGuardChampion_ua.cc330585.webp";